import { SlidingStatBar } from 'app/layouts/stats/sliding';
import { PrimaryStatCard } from 'app/shared/cards';
import { useMessagingReportService } from 'hooks/messaging/report';
import React, { useEffect, useState } from 'react';

export const SMSStatBar = ({ id }) => {
  const { fetchReports } = useMessagingReportService();

  const [logs, setLogs] = useState({});

  useEffect(() => {
    if (!id) return;

    fetchReports({ query_string: `resource_id=${id}` }).then(({ logs }) => {
      let sent = 0;
      let failed = 0;

      logs.forEach((log) => {
        sent += log.stats?.sent || 0;
        failed += log.stats?.failed || 0;
      });

      setLogs((curr_logs) => ({
        ...curr_logs,
        sent,
        failed
      }));
    });
  }, [id]);

  return (
    <>
      <SlidingStatBar>
        <PrimaryStatCard
          main_stat={{
            label: 'Sent',
            value: logs.sent,
            color: 'var(--blue-primary)'
          }}
          bottom_stat={{ label: '-', value: '-' }}
        />
        <PrimaryStatCard
          main_stat={{
            label: 'Failed',
            value: logs.failed,
            color: 'var(--red-primary)'
          }}
          bottom_stat={{ label: '-', value: '-' }}
        />
      </SlidingStatBar>
    </>
  );
};
